import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Logo from '../components/Logo';
import {
  bodyFont,
  footerBg,
  footerLink,
  footerMuted,
  footerText,
  white,
} from '../theme/palette';

// The dark band closes the page rather than continuing it — the rest of the
// site is white with hard ink outlines, so the footer is the one place that
// inverts. Colour tokens for this treatment already existed in the palette.
const Footer = styled.footer`
  padding: 44px 40px 40px;
  background: ${footerBg};
  color: ${footerText};

  @media (max-width: 768px) {
    padding: 34px 20px 32px;
  }
`;

const Inner = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 28px;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  width: fit-content;
`;

const Legal = styled.p`
  margin: 0;
  font: 400 13.5px/1.6 ${bodyFont};
  color: ${footerMuted};
`;

const Columns = styled.nav`
  display: flex;
  gap: 56px;

  @media (max-width: 480px) {
    gap: 32px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ColumnLabel = styled.h2`
  margin: 0 0 2px;
  font: 700 11px/1 ${bodyFont};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${footerMuted};
`;

const FooterLink = styled(Link)`
  font: 400 13.5px/1.4 ${bodyFont};
  color: ${footerLink};
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: ${white};
    text-decoration: underline;
  }
`;

export default function SiteFooter() {
  return (
    <Footer>
      <Inner>
        <Brand>
          <BrandLink to="/" aria-label="Poplearn home">
            <Logo height={32} fill={white} wordmarkSize={19} />
          </BrandLink>
          <Legal>
            Poplearn by Urple, LLC &copy;{new Date().getFullYear()}
          </Legal>
        </Brand>

        <Columns aria-label="Footer">
          <Column>
            <ColumnLabel>Product</ColumnLabel>
            <FooterLink to="/pricing">Pricing</FooterLink>
            <FooterLink to="/blog">Blog</FooterLink>
            <FooterLink to="/support">Support</FooterLink>
          </Column>
          <Column>
            <ColumnLabel>Legal</ColumnLabel>
            <FooterLink to="/terms">Terms of Service</FooterLink>
            <FooterLink to="/privacy">Privacy Policy</FooterLink>
          </Column>
          <Column>
            <ColumnLabel>Policies</ColumnLabel>
            <FooterLink to="/cookies">Cookie Policy</FooterLink>
            <FooterLink to="/acceptable-use">Acceptable Use</FooterLink>
          </Column>
        </Columns>
      </Inner>
    </Footer>
  );
}
